const EduEspYesNoNA = {
  Yes: 146,
  No: 147,
  NA: 148,
};

export default EduEspYesNoNA;
